import { constants } from "@newsela/angelou";

const coreBlue = constants.colors.ui.core[600];
const white = constants.colors.ui.white["700"];

export const banner = {
  background: coreBlue,
  color: white,
  fontWeight: 100,
  minHeight: "2.5rem",
  display: "flex",
  flexFlow: "row nowrap",
  justifyContent: "center",
  padding: "0.5rem 1rem",
};

export const bannerMsg = {
  flexGrow: 1,
  textAlign: "center",
};

export const bannerBtn = {
  flexGrow: 0,
  fontWeight: "700",
  display: "flex",
  alignItems: "center",
  svg: {
    height: "1em",
    width: "1em",
    marginRight: "0.5em",
  },
};
